import React, { useCallback, useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import Isvg from 'react-inlinesvg'
// Components
import { Dropzone_s } from 'components/import-export/import-styles'
import ConfirmationModal from "components/modal/confirmation-modal"
// Data
import snapshotService from "data/snapshots"
// Icons
import { CloseIcon } from "images/icons/general/"
import { UploadSnapshotIcon } from "images/icons/tools/"
// Styles
import { Button_s } from "styles/app-styles"
import { UploadSnapshot_s } from 'components/snapshots/snapshot-styles'

const UploadSnapshot = (props: {toggleDropzone: Function}) => {
  const [showConfModal, toggleConfModal] = useState<boolean>(false);
  const [restoreConfMessage, setRestoreConfMessage] = useState<string>("");
  const [snapshotId, setSnapshotId] = useState<number|null>(null)

  const onDrop = useCallback((acceptedFiles) => {
    snapshotService.uploadSnapshot(acceptedFiles[0])
  }, [])
  const {getRootProps, getInputProps} = useDropzone({onDrop})

  useEffect(() => {
    const snapshotEventSubscription = snapshotService.eventStream().subscribe(e => {
      if( e.type === "SNAPSHOT_RESTORE_CONF"){
        const message = e.payload.message.split('\n').flatMap(s => [s, <br/>])
        setRestoreConfMessage(message)
        setSnapshotId(e.payload.snapshotId)
        toggleConfModal(true)
      }
      if( e.type === "SNAPSHOT_RESTORE_COMPLETE"){
        cancel()
      }
    })

    return function cleanup() {
      snapshotEventSubscription.unsubscribe()
    }
  }, [])

  function cancel(){
    setRestoreConfMessage("")
    toggleConfModal(false)
    setSnapshotId(null)
  }

  function triggerRestore(){
    snapshotService.restore(snapshotId!)
    cancel()
    props.toggleDropzone(false)
  }

  return (
    <UploadSnapshot_s>
      <Dropzone_s {...getRootProps()}>
        <div>
          <span>Upload File</span>
          <a onClick={(e) => { e.stopPropagation(); }}><Isvg src={CloseIcon} /></a>
        </div>
        <div>
          <input {...getInputProps()} />
          <Isvg src={UploadSnapshotIcon} />
          <p>Please choose a file from your computer and Drag & Drop into this area or use the button below to browse for a file</p>
          <Button_s primary>Browse and Upload</Button_s>
          <Button_s onClick={(e) => { e.stopPropagation(); props.toggleDropzone(false) }}>Cancel</Button_s>
        </div>
      </Dropzone_s>

      <ConfirmationModal
        show={showConfModal}
        toggleShow={toggleConfModal}
        title={'Restore Information'}
        confirmText={'Restore'}
        confirmFunc={()=>triggerRestore()}
        cancelFunc={()=>cancel()}
        message={restoreConfMessage}
        confirmOnly={false}
        closeOnly={false}
      />
    </UploadSnapshot_s>
  )
}

export default UploadSnapshot